import store from '@/store'
import i18n from '@/plugins/vue-i18n'
import { messageErrorRequest } from '@/helpers/validation'

export function handleError(err, options = {}) {
  if (err.code === 'ERR_CANCELED') return
  const { message: customMessage, ...translateKey } = options
  let message = customMessage !== undefined ? customMessage : messageErrorRequest(err, translateKey)
  if (err.response?.status === 524) message = i18n.t('error.cloudflare')
  store.dispatch('NotificationModule/show', { type: 'error', message })
}